import React, { Component } from 'react'
import { Table } from 'antd'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Location',
    dataIndex: 'address',
  },
  {
    title: 'Camera',
    dataIndex: 'address',
  },
  {
    title: 'Total calls',
    dataIndex: 'address',
  },
  {
    title: 'Status',
    dataIndex: 'address',
  },
]
const data = []
export default class ECBTable extends Component {
  render() {
    return <Table columns={columns} dataSource={data} />
  }
}
